<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Project Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${project.publicNumber()}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'edit project'">
      <template #gated-content>
        <project-form :project="project" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import ProjectForm from '@/components/lab/project/ProjectForm.vue'
import { LabRepositoryFactory } from '@/repositories/lab/LabRepositoryFactory'
import { notificationOptions } from "@/shared/toast-notification-options";
import { projectNotifications } from "@/shared/notifications"

const ProjectRepository = LabRepositoryFactory.get("project")

Vue.use(VueNotifications, notificationOptions)

export default {
  name: "ProjectEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    ProjectForm
  },
  data () {
    return {
      loading: true,
      project_id: this.$route.params.project_id || null,
      project: null,
    }
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/projects/${this.project_id}`,
            title: "View Project",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit (form_data) {
      try {
        await ProjectRepository.update(this.project.id, form_data)

        this.editSuccess()
        this.$router.push(`/projects/${this.project_id}`)
      } catch ({ response }) {
        const { status, data } = response.response

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        })
      }
    }
  },
  async mounted () {
    this.loading = true

    this.project = await getModel({
      model_type: 'project',
      id: this.project_id,
      message: this.$bvToast
    })

    this.loading = false
  },
  notifications: projectNotifications,
}
</script>
